import { useState } from "react";
import { achievements, C } from "@bd/content";
import { dateOf } from "@bd/sim";
import { Icon, Sheet, Tabs } from "@bd/ui-kit";
import { me, useGame } from "../store";
import { t, tp, tdate, tx } from "../i18n";

/** Achievements (30 of them hidden until earned) and the story arcs this company has lived through. */
export function Achievements() {
  const game = useGame((s) => s.game)!;
  const set = useGame((s) => s.set);
  const co = me(game)!;
  const [tab, setTab] = useState<"achievements" | "stories">("achievements");
  const got = new Map(co.achievements.map((a) => [a.id, a.week]));
  const hiddenLeft = achievements.filter((a) => a.hidden && !got.has(a.id)).length;
  const list = [...achievements].sort((a, b) => Number(got.has(b.id)) - Number(got.has(a.id)));
  return (
    <Sheet title={t("Achievements")} badge={<span className="ichip" title={t("{n} of {total} earned", { n: got.size, total: achievements.length })}><Icon name="star" size={14} color="var(--gold)" />{got.size}/{achievements.length}</span>} onClose={() => set({ screen: { kind: "menu" } })} wide testId="achievements">
      <Tabs tabs={[{ id: "achievements", label: t("Achievements") }, { id: "stories", label: t("Stories ({n})", { n: co.arcs.length }) }]} value={tab} onChange={setTab} />
      {tab === "achievements" && (
        <div className="grid2" style={{ marginTop: 12, gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))" }}>
          {list.filter((a) => !a.hidden || got.has(a.id)).map((a) => (
            <div key={a.id} className="card row" style={{ padding: "8px 12px", opacity: got.has(a.id) ? 1 : 0.6 }} title={got.has(a.id) ? `${t(a.desc)} · ${tdate(dateOf(got.get(a.id)!).label)}` : t(a.desc)} data-testid={got.has(a.id) ? "achievement-earned" : "achievement-locked"}>
              <Icon name={got.has(a.id) ? "star" : "lock"} size={20} color={got.has(a.id) ? "var(--gold)" : "var(--muted)"} />
              {/* earned: the name and the year on one line; still to get: what it takes, on one more */}
              {got.has(a.id) ? (
                <>
                  <strong className="ellipsis" style={{ flex: 1 }}>{t(a.name)}</strong>
                  <span className="muted num" style={{ fontSize: "0.85rem" }}>{dateOf(got.get(a.id)!).year}</span>
                </>
              ) : (
                <div style={{ minWidth: 0, flex: 1 }}>
                  <strong className="ellipsis" style={{ display: "block" }}>{t(a.name)}</strong>
                  <div className="muted ellipsis" style={{ fontSize: "0.8rem" }}>{t(a.desc)}</div>
                </div>
              )}
            </div>
          ))}
          {hiddenLeft > 0 && (
            <div className="card row" style={{ padding: "8px 12px", opacity: 0.6 }} title={tp(hiddenLeft, "Plus {n} secret one. Unusual play finds it.", "Plus {n} secret ones. Unusual play finds them.")} data-testid="achievements-secret">
              <Icon name="lock" size={20} color="var(--muted)" />
              <strong className="num">? × {hiddenLeft}</strong>
            </div>
          )}
        </div>
      )}
      {tab === "stories" && (
        <div className="stack" style={{ marginTop: 12 }}>
          {co.arcs.length === 0 && <span className="muted">{t("No stories yet.")}</span>}
          {co.arcs.map((run) => (
            <div key={run.id} className="card stack" style={{ padding: "10px 14px", gap: 4 }} data-testid="story">
              <span className="spread">
                <strong>{t(C.arc[run.id]?.name ?? run.id)}</strong>
                <span className="ichip plain muted" title={run.doneWeek !== undefined ? t("Began {start}, ended {end}", { start: tdate(dateOf(run.started).label), end: tdate(dateOf(run.doneWeek).label) }) : t("Began {start}, still going", { start: tdate(dateOf(run.started).label) })}>
                  <Icon name="calendar" size={13} />{dateOf(run.started).year}–{run.doneWeek !== undefined ? dateOf(run.doneWeek).year : ""}
                </span>
              </span>
              {run.ending && <span>{tx(run.ending)}</span>}
            </div>
          ))}
        </div>
      )}
    </Sheet>
  );
}
